import { createContext, useContext } from 'react';
import usePermissionsEditor from './usePermissionsEditor';

type PermissionsContextValue = {
  editor: ReturnType<typeof usePermissionsEditor>;
  readOnly: boolean;
  formID: string;
};

export const PermissionsContext = createContext<PermissionsContextValue | null>(null);

/** Read by the `<Permissions>` compound parts and their internal pieces, which only render under the root. */
export function usePermissionsContext(): PermissionsContextValue {
  const value = useContext(PermissionsContext);

  if (!value) throw new Error('Permissions parts must render inside <Permissions>.');

  return value;
}
